import React, { CSSProperties, FunctionComponent } from "react";
import styles from "./styles.module.scss";
import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Typography,
  useTheme
} from "@mui/material";
import { CustomLoadingIndicator } from "../CustomLoadingIndicator";
import { LazyImageAspectFit } from "../LazyImageAspectFit";
import { IconType } from "../../icons/IconType";
import { Icon } from "../../icons/Icon";

export const RightDetailListItem: FunctionComponent<IRightDetailListItemProps> = ({
  title,
  style,
  detail,
  subtitle,
  leftSubtitle,
  titleColor,
  textColor,
  isLoading,
  onClick,
  iconType,
  theNewIconType,
  rightIconType,
  detailImage,
  disabled,
  boldTitle,
  detailBlurred,
  children
}) => {
  const theme = useTheme();
  return (
    <ListItemButton
      className={detailImage ? styles.itemWithDetailImage : styles.itemWithoutDetailImage}
      sx={{ opacity: "1 !important" }}
      style={style}
      onClick={event => {
        if (onClick) {
          onClick(event);
        }
      }}
      disabled={disabled}
    >
      <div className={styles.itemDiv}>
        {iconType && (
          <ListItemIcon>
            <Icon type={iconType} />
          </ListItemIcon>
        )}
        <ListItemText
          primary={
            <Typography
              className={styles.titlePrimary}
              component={"div"}
              style={{
                color: titleColor ?? theme.palette.primary.main,
                fontWeight: boldTitle ? "bold" : "normal"
              }}
            >
              {title}
            </Typography>
          }
          secondary={
            <Typography
              className={styles.titleSecondary}
              component={"div"}
              style={{ color: theme.palette.primary.subtitle }}
            >
              {leftSubtitle}
            </Typography>
          }
        />
        <Box className={styles.loadingDiv}>
          {isLoading ? (
            <CustomLoadingIndicator />
          ) : (
            theNewIconType && (
              <ListItemIcon>
                <Icon type={theNewIconType} />
              </ListItemIcon>
            )
          )}
        </Box>
        {children}
        <ListItemText
          className={styles.listItemText}
          primary={
            <Typography
              className={styles.detailPrimary}
              component={"div"}
              style={{
                color: textColor ?? theme.palette.primary.main,
                filter: detailBlurred ? "blur(4px)" : undefined
              }}
            >
              {detail}
            </Typography>
          }
          secondary={
            <Typography
              className={styles.detailSecondary}
              component={"div"}
              style={{ color: theme.palette.primary.subtitle }}
            >
              {subtitle}
            </Typography>
          }
          sx={{ textAlign: "right" }}
        />
        {rightIconType && (
          <SvgIcon>
            <Icon type={rightIconType} />
          </SvgIcon>
        )}
      </div>
      {detailImage && (
        <LazyImageAspectFit
          className={styles.detailImageContainer}
          image={detailImage}
          defaultImage={detailImage}
          alt={"Image"}
        />
      )}
    </ListItemButton>
  );
};

export interface IRightDetailListItemProps {
  children?: React.ReactNode;
  style?: CSSProperties;
  title: string;
  detail?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  leftSubtitle?: string;
  titleColor?: string;
  textColor?: string;
  isLoading?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  iconType?: IconType;
  theNewIconType?: IconType;
  rightIconType?: IconType;
  detailImage?: string;
  disabled?: boolean;
  boldTitle?: boolean;
  detailBlurred?: boolean;
}
